import axios from 'axios';
import Jsona from 'jsona';
import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export const dataFormatter = new Jsona();

export const getters = {
    groupedAlerts(state) {
        return state.alerts.reduce((r, v, i, a, k = v.variant) => ((r[k] || (r[k] = [])).push(v), r), {});
    },
};

export const actions = {
    async fetchAlerts(context, {queryString = '?filter[display]=in-app'}) {
        try {
            const response = await axios.get(`${process.env.VUE_APP_ADMIN_URL_USERS}/api/v1/alerts/${queryString}`);

            context.commit('SET_ALERTS', dataFormatter.deserialize(response.data));

            return response;
        } catch (err) {
            return false;
        }
    },
};

export const mutations = {
    SET_ALERTS(state, alerts) {
        state.alerts = alerts;
    },
};

export const state = () => {
    return {
        alerts: [],
    };
};

export default {
    namespaced: true,
    getters,
    actions,
    mutations,
    state: state(),
};
